<template>
  <b-container>
    <base-error-container :modelstate="modelstate"></base-error-container>

    <!-- <div>cargoTypes</div><div>{{cargoTypes}}</div> -->
    <!-- <div>cargoTypeId</div><div>{{model.cargoTypeId}}</div> -->
    <!-- <div>optionsStatus</div><div>{{optionsStatus}}</div> -->

    <div class="mb-2">
      <base-row-detail
        v-if="this.model.cargoId"
        label="Id"
        :value="`#${this.model.cargoId}`"
      ></base-row-detail>

      <base-row-detail
        :label="$t('geral.active')"
        :value="`${this.isCargoActiveText}`"
      ></base-row-detail>

      <base-row-detail
        v-if="
          model.reasonForStatusChange != '' &&
          model.reasonForStatusChange != null
        "
        :label="$t('tracking.cargo.reasonForStatusChange')"
        :value="`${this.model.reasonForStatusChange}`"
      ></base-row-detail>
    </div>

    <!-- CargoTypeId -->
    <b-form-group
      v-if="model.permissions == 1"
      :label="$t('tracking.cargo.cargoType')"
      label-for="CargoTypeId"
    >
      <b-form-select
        id="CargoTypeId"
        :options="optionsCargoType"
        v-model="model.cargoTypeId"
      >
      </b-form-select>
      <span class="text-danger" v-if="modelstate['CargoTypeId']">
        {{ modelstate["CargoTypeId"][0] }}
      </span>
    </b-form-group>
    <b-form-group
      v-else
      :label="$t('tracking.cargo.cargoType')"
      label-for="CargoTypeId"
    >
      <b-form-select
        id="CargoTypeId"
        :options="optionsCargoType"
        v-model="model.cargoTypeId"
        :disabled="readonly"
      >
      </b-form-select>
      <span class="text-danger" v-if="modelstate['CargoTypeId']">
        {{ modelstate["CargoTypeId"][0] }}
      </span>
    </b-form-group>

    <!-- Status -->
    <b-form-group :label="$t('tracking.cargo.status')" label-for="Status">
      <b-form-select
        id="Status"
        :options="optionsStatus"
        v-model="model.status"
        :disabled="readonly"
      >
      </b-form-select>
      <span class="text-danger" v-if="modelstate['Status']">
        {{ modelstate["Status"][0] }}
      </span>
    </b-form-group>

    <!-- ClientDocumentType -->
    <b-form-group
      :label="$t('tracking.cargo.clientDocumentType')"
      label-for="ClientDocumentType"
    >
      <b-form-select
        id="ClientDocumentType"
        :options="optionsDocumentType"
        v-model="model.clientDocumentType"
        :disabled="readonly"
      ></b-form-select>
      <span class="text-danger" v-if="modelstate['ClientDocumentType']">
        {{ modelstate["ClientDocumentType"][0] }}
      </span>
    </b-form-group>

    <!-- ClientPersonalDocument -->
    <b-form-group
      v-if="model.clientDocumentType == 'CPF'"
      :label="$t('tracking.cargo.clientPersonalDocument')"
      label-for="ClientPersonalDocument"
    >
      <b-form-input
        id="ClientPersonalDocument"
        type="text"
        :placeholder="$t('tracking.cargo.clientPersonalDocument')"
        v-model="model.clientPersonalDocument"
        v-mask="'999.999.999-99'"
        :readonly="readonly"
      />
      <span class="text-danger" v-if="modelstate['ClientPersonalDocument']">
        {{ modelstate["ClientPersonalDocument"][0] }}
      </span>
    </b-form-group>

    <!-- ClientCompanyDocument -->
    <b-form-group
      v-if="model.clientDocumentType == 'CNPJ'"
      :label="$t('tracking.cargo.clientCompanyDocument')"
      label-for="ClientCompanyDocument"
    >
      <b-form-input
        id="ClientCompanyDocument"
        type="text"
        :placeholder="$t('tracking.cargo.clientCompanyDocument')"
        v-model="model.clientCompanyDocument"
        v-mask="'99.999.999/9999-99'"
        :readonly="readonly"
      />
      <span class="text-danger" v-if="modelstate['ClientCompanyDocument']">
        {{ modelstate["ClientCompanyDocument"][0] }}
      </span>
    </b-form-group>

    <!-- ClientName -->
    <b-form-group
      :label="$t('tracking.cargo.clientName')"
      label-for="ClientName"
    >
      <b-form-input
        id="ClientName"
        type="text"
        :placeholder="$t('tracking.cargo.clientName')"
        v-model="model.clientName"
        :readonly="readonly"
      />
      <span class="text-danger" v-if="modelstate['ClientName']">
        {{ modelstate["ClientName"][0] }}
      </span>
    </b-form-group>

    <!-- CompanyBranchName -->
    <!-- <div>{{model }}</div> -->
    <b-form-group
      :label="$t('tracking.cargo.companyBranchName')"
      label-for="cargoDescription"
    >
      <company-branch-dropdown
        id="companyBranchId"
        :value.sync="model.companyBranchId"
        :readonly="readonly"
      >
      </company-branch-dropdown>
      <span class="text-danger" v-if="modelstate['CompanyBranchName']">
        {{ modelstate["CompanyBranchName"][0] }}
      </span>
    </b-form-group>
    <!-- <b-form-group
      :label="$t('tracking.cargo.companyBranchName')"
      label-for="cargoDescription"
    >
      <b-form-input
        id="CompanyBranchName"
        type="text"
        :placeholder="$t('tracking.cargo.companyBranchName')"
        v-model="model.companyBranchName"
        :readonly="readonly"
      />
      <span class="text-danger" v-if="modelstate['CompanyBranchName']">
        {{ modelstate["CompanyBranchName"][0] }}
      </span>
    </b-form-group> -->

    <cargo-crud-status-opened
      :model="model"
      :modelstate="modelstate"
      :readonly="readonly"
      :create="create"
    />

    <!-- DateAttendanceExpiration -->
    <b-form-group
      :label="$t('tracking.cargo.dateAttendanceExpiration')"
      label-for="DateAttendanceExpiration"
    >
      <b-form-input
        type="date"
        id="DateAttendanceExpiration"
        :placeholder="$t('tracking.cargo.dateAttendanceExpiration')"
        v-model="model.dateAttendanceExpiration"
        :readonly="readonly"
      />
      <span class="text-danger" v-if="modelstate['DateAttendanceExpiration']">
        {{ modelstate["DateAttendanceExpiration"][0] }}
      </span>
    </b-form-group>

    <!-- OriginStateId -->
    <b-form-group
      :label="$t('tracking.cargo.originState')"
      label-for="OriginStateId"
    >
      <b-form-select
        id="OriginStateId"
        :options="optionsState"
        v-model="model.originStateId"
        :disabled="readonly"
      >
      </b-form-select>
      <span class="text-danger" v-if="modelstate['OriginStateId']">
        {{ modelstate["OriginStateId"][0] }}
      </span>
    </b-form-group>

    <!-- OriginCityId -->
    <b-form-group
      :label="$t('tracking.cargo.originCity')"
      label-for="OriginCityId"
    >
      <city-dropdown
        id="OriginCityId"
        :readonly="readonly"
        :state-id="parseInt(model.originStateId)"
        :city-id="model.originCityId"
        :changeData.sync="model.originCityId"
      >
      </city-dropdown>
      <span class="text-danger" v-if="modelstate['OriginCityId']">
        {{ modelstate["OriginCityId"][0] }}
      </span>
    </b-form-group>

    <!-- DestinationStateId -->
    <b-form-group
      :label="$t('tracking.cargo.destinationState')"
      label-for="DestinationStateId"
    >
      <b-form-select
        id="DestinationStateId"
        :options="optionsState"
        v-model="model.destinationStateId"
        :disabled="readonly"
      >
      </b-form-select>
      <span class="text-danger" v-if="modelstate['DestinationStateId']">
        {{ modelstate["DestinationStateId"][0] }}
      </span>
    </b-form-group>

    <!-- DestinationCityId -->
    <b-form-group
      :label="$t('tracking.cargo.destinationCity')"
      label-for="DestinationCityId"
    >
      <city-dropdown
        id="DestinationCityId"
        :readonly="readonly"
        :state-id="parseInt(model.destinationStateId)"
        :city-id="model.destinationCityId"
        :changeData.sync="model.destinationCityId"
      >
      </city-dropdown>
      <span class="text-danger" v-if="modelstate['DestinationCityId']">
        {{ modelstate["DestinationCityId"][0] }}
      </span>
    </b-form-group>

    <!-- VehicleTypeId -->
    <b-form-group
      :label="$t('tracking.cargo.vehicleType')"
      label-for="VehicleTypeId"
    >
      <b-form-select
        id="VehicleTypeId"
        :options="optionsVehicleType"
        v-model="model.vehicleTypeId"
        :disabled="readonly"
      >
      </b-form-select>
      <span class="text-danger" v-if="modelstate['VehicleTypeId']">
        {{ modelstate["VehicleTypeId"][0] }}
      </span>
    </b-form-group>

    <!-- Weight -->
    <b-form-group :label="$t('tracking.cargo.weight')" label-for="Weight">
      <base-input-numeric
        id="Weight"
        :placeholder="$t('tracking.cargo.weight')"
        :readonly="readonly"
        :value.sync="model.weight"
      >
      </base-input-numeric>
      <span class="text-danger" v-if="modelstate['Weight']">
        {{ modelstate["Weight"][0] }}
      </span>
    </b-form-group>

    <!-- Cubage -->
    <b-form-group :label="$t('tracking.cargo.cubage')" label-for="Cubage">
      <base-input-numeric
        id="Cubage"
        :placeholder="$t('tracking.cargo.cubage')"
        :readonly="readonly"
        :value.sync="model.cubage"
      >
      </base-input-numeric>
      <span class="text-danger" v-if="modelstate['Cubage']">
        {{ modelstate["Cubage"][0] }}
      </span>
    </b-form-group>

    <!-- PalletsQuantity -->
    <b-form-group
      :label="$t('tracking.cargo.palletsQuantity')"
      label-for="PalletsQuantity"
    >
      <base-input-numeric
        id="PalletsQuantity"
        :placeholder="$t('tracking.cargo.palletsQuantity')"
        :readonly="readonly"
        :value.sync="model.palletsQuantity"
      >
      </base-input-numeric>
      <span class="text-danger" v-if="modelstate['PalletsQuantity']">
        {{ modelstate["PalletsQuantity"][0] }}
      </span>
    </b-form-group>

    <!-- DeliveryValue -->
    <b-form-group
      :label="$t('tracking.cargo.deliveryValue')"
      label-for="DeliveryValue"
    >
      <base-input-numeric
        id="DeliveryValue"
        :placeholder="$t('tracking.cargo.deliveryValue')"
        :readonly="readonly"
        :value.sync="model.deliveryValue"
      >
      </base-input-numeric>
      <span class="text-danger" v-if="modelstate['DeliveryValue']">
        {{ modelstate["DeliveryValue"][0] }}
      </span>
    </b-form-group>

    <!-- DateAttendance -->
    <!-- <b-form-group
      :label="$t('tracking.cargo.dateAttendance')"
      label-for="DateAttendance"
    >
      <b-form-input
        type="date"
        id="DateAttendance"
        :placeholder="$t('tracking.cargo.dateAttendance')"
        v-model="model.dateAttendance"
        :readonly="readonly"
      />
      <span class="text-danger" v-if="modelstate['DateAttendance']">
        {{ modelstate["DateAttendance"][0] }}
      </span>
    </b-form-group> -->

    <!-- TransportNumber -->
    <b-form-group
      :label="$t('tracking.cargo.transportNumber')"
      label-for="transportNumber"
    >
      <b-form-input
        id="transportNumber"
        :placeholder="$t('tracking.cargo.transportNumber')"
        v-model="model.transportNumber"
        :readonly="readonly"
      />
      <span class="text-danger" v-if="modelstate['TransportNumber']">
        {{ modelstate["TransportNumber"][0] }}
      </span>
    </b-form-group>

    <!-- AdditionalInfortion -->
    <b-form-group
      :label="$t('tracking.cargo.additionalInformation')"
      label-for="additionalInformation"
    >
      <b-form-textarea
        id="additionalInformation"
        :placeholder="$t('tracking.cargo.additionalInformation')"
        v-model="model.additionalInformation"
        :readonly="readonly"
      />
      <span class="text-danger" v-if="modelstate['AdditionalInformation']">
        {{ modelstate["AdditionalInformation"][0] }}
      </span>
    </b-form-group>

    <div v-if="isStatusNonAttendance">
      <cargo-crud-status-non-attendance
        id="NonAttendanceReason"
        :model="model"
        :modelstate="modelstate"
        :readonly="readonly"
      >
      </cargo-crud-status-non-attendance>
    </div>

    <div v-if="isStatusSearchVehicle">
      <cargo-crud-status-search-vehicle
        :model="model"
        :modelstate="modelstate"
        :readonly="readonly"
      >
      </cargo-crud-status-search-vehicle>
    </div>

    <div v-if="isStatusChecklistLoading">
      <cargo-crud-status-checklist-loading
        :model="model"
        :modelstate="modelstate"
        :readonly="readonly"
      >
      </cargo-crud-status-checklist-loading>
    </div>
    <div v-if="isStatusScheduler">
      <cargo-crud-status-scheduler
        :model="model"
        :modelstate="modelstate"
        :readonly="readonly"
      >
      </cargo-crud-status-scheduler>
    </div>

    <div v-if="isStatusWaitingCollect">
      <cargo-crud-status-waiting-collect
        :model="model"
        :modelstate="modelstate"
        :readonly="readonly"
      >
      </cargo-crud-status-waiting-collect>
    </div>

    <div v-if="isStatusLoading">
      <cargo-crud-status-loading
        :model="model"
        :modelstate="modelstate"
        :readonly="readonly"
      >
      </cargo-crud-status-loading>
    </div>
    <div v-if="isStatusWaitingDocuments">
      <cargo-crud-status-waiting-documents
        :model="model"
        :modelstate="modelstate"
        :readonly="readonly"
      >
      </cargo-crud-status-waiting-documents>
    </div>

    <div v-if="isStatusInTraffic">
      <cargo-crud-status-in-traffic
        :model="model"
        :modelstate="modelstate"
        :readonly="readonly"
      >
      </cargo-crud-status-in-traffic>
    </div>

    <div v-if="isStatusWaitingUnload">
      <cargo-crud-status-waiting-unload
        :model="model"
        :modelstate="modelstate"
        :readonly="readonly"
      >
      </cargo-crud-status-waiting-unload>
    </div>

    <div v-if="isStatusUnloading">
      <cargo-crud-status-unloading
        :model="model"
        :modelstate="modelstate"
        :readonly="readonly"
      >
      </cargo-crud-status-unloading>
      <b-button class="mb-4" size="sm" @click.prevent="openImage()">
        <i class="tim-icons icon-camera-18 mb-1 mr-2"></i>
        Mostrar canhoto
      </b-button>
      <fullscreen-sidebar ref="fullscreenSidebar">
        <template v-slot:content>
          <img :src="attachmentUrl" class="fullscreen-sidebar-img" />
        </template>
      </fullscreen-sidebar>
    </div>
    <!-- <div>Date: {{dateAttendance}}</div> -->
    <!-- <div>{{ model }}</div> -->
    <!-- <div>model.weight: {{model.weight}}</div> -->
  </b-container>
</template>

<script>
import AwesomeMask from "awesome-mask";
import BaseErrorContainer from "../../base/BaseErrorContainer.vue";
import BaseInputNumeric from "../../base/BaseInputNumeric.vue";
import BaseRowDetail from "../../base/BaseRowDetail.vue";
import CargoCrudStatusChecklistLoading from "@/components_rms/tracking/cargo/status/CargoCrudStatusChecklistLoading.vue";
import CargoCrudStatusInTraffic from "@/components_rms/tracking/cargo/status/CargoCrudStatusInTraffic.vue";
import CargoCrudStatusLoading from "@/components_rms/tracking/cargo/status/CargoCrudStatusLoading.vue";
import CargoCrudStatusOpened from "@/components_rms/tracking/cargo/status/CargoCrudStatusOpened.vue";
import CargoCrudStatusScheduler from "@/components_rms/tracking/cargo/status/CargoCrudStatusScheduler.vue";
import CargoCrudStatusSearchVehicle from "@/components_rms/tracking/cargo/status/CargoCrudStatusSearchVehicle.vue";
import CargoCrudStatusUnloading from "@/components_rms/tracking/cargo/status/CargoCrudStatusUnloading.vue";
import CargoCrudStatusWaitingCollect from "@/components_rms/tracking/cargo/status/CargoCrudStatusWaitingCollect.vue";
import CargoCrudStatusWaitingDocuments from "@/components_rms/tracking/cargo/status/CargoCrudStatusWaitingDocuments.vue";
import CargoCrudStatusWaitingUnload from "@/components_rms/tracking/cargo/status/CargoCrudStatusWaitingUnload.vue";
import CargoCrudStatusNonAttendance from "./status/CargoCrudStatusNonAttendance.vue";
import CompanyBranchDropdown from "@/components_rms/company/CompanyBranchDropdown.vue";
import FullscreenSidebar from "@/components_rms/FullscreenSidebar.vue";

export default {
  name: "CargoCrudData",
  directives: {
    mask: AwesomeMask,
  },
  props: {
    model: Object,
    modelstate: Object,
    readonly: Boolean,
    create: Boolean,
  },
  components: {
    BaseErrorContainer,
    BaseInputNumeric,
    BaseRowDetail,
    CargoCrudStatusChecklistLoading,
    CargoCrudStatusInTraffic,
    CargoCrudStatusLoading,
    CargoCrudStatusNonAttendance,
    CargoCrudStatusOpened,
    CargoCrudStatusScheduler,
    CargoCrudStatusSearchVehicle,
    CargoCrudStatusUnloading,
    CargoCrudStatusWaitingCollect,
    CargoCrudStatusWaitingDocuments,
    CargoCrudStatusWaitingUnload,
    CityDropdown: () => import("@/components_rms/System/city/CityDropdown.vue"),
    CompanyBranchDropdown,
    FullscreenSidebar,
  },
  data() {
    return {
      attachmentUrl: "",
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      optionsCargoType: [
        { value: 1, text: "Contrato" },
        { value: 2, text: "Subcontrato" },
      ],
      optionsDocumentType: ["CPF", "CNPJ"],
      optionsState: [{ value: null, text: "Carregando cidades" }],
      optionsStatus: [{ value: 0, text: "Carregando..." }],
      optionsVehicleType: [
        { value: null, text: "Carregando tipos de veículo" },
      ],
      cargoTypes: [],
      dateAttendance: null,
      hourAttendance: null,
    };
  },
  created() {
    this.loadStates();
    this.loadVehicleTypes();
    this.refreshModel();
    this.loadOccurrencies();
    // this.loadNonAttendanceReason();
  },
  computed: {
    isCargoActiveText() {
      if (!this.model) return "Não";
      if (!this.model.cargoActive) return "Não";
      return "Sim";
    },
    isStatusSearchVehicle() {
      // { value: 2, text: "Procurando veiculo" },
      if (this.model.status == 2) return true;
      if (this.model.cargoTypeId == 1) {
        if (this.isStatusChecklistLoading) return true;
      } else {
        if (this.isStatusWaitingDocuments) return true;
      }
      return false;
    },
    isStatusChecklistLoading() {
      // { value: 3, text: "Checklist de carregamento" },
      if (this.model.cargoTypeId != 1) return false;
      if (this.model.status == 3) return true;
      if (this.isStatusScheduler) return true;
      return false;
    },
    isStatusScheduler() {
      // { value: 4, text: "Agendado" },
      if (this.model.cargoTypeId != 1) return false;
      if (this.model.status == 4) return true;
      if (this.isStatusWaitingCollect) return true;
      return false;
    },
    isStatusWaitingCollect() {
      // { value: 5, text: "Aguardando coleta" },
      if (this.model.cargoTypeId != 1) return false;
      if (this.model.status == 5) return true;
      if (this.isStatusLoading) return true;
      return false;
    },
    isStatusLoading() {
      // { value: 6, text: "Carregando" },
      if (this.model.cargoTypeId != 1) return false;
      if (this.model.status == 6) return true;
      if (this.isStatusWaitingDocuments) return true;
      return false;
    },
    isStatusWaitingDocuments() {
      if (this.model.status == 7) {
        return true;
      }
      if (this.isStatusInTraffic) {
        return true;
      }
      return false;
    },
    isStatusInTraffic() {
      // { value: 8, text: "Em transito" },
      if (this.model.status == 8) {
        return true;
      }
      if (this.isStatusWaitingUnload) {
        return true;
      }
      return false;
    },
    isStatusWaitingUnload() {
      // { value: 9, text: "Aguardando descarga" },
      if (this.model.status == 9) {
        return true;
      }
      if (this.isStatusUnloading) {
        return true;
      }
      return false;
    },
    isStatusUnloading() {
      // { value: 10, text: "Descarregando" },
      if (this.model.status == 10) {
        return true;
      }
      if (this.isStatusDelivered) {
        return true;
      }
      return false;
    },
    isStatusDelivered() {
      // { value: 11, text: "Entregue" }
      if (this.model.status == 11) {
        return true;
      }
      return false;
    },
    isStatusNonAttendance() {
      if (this.model.status == 12) {
        return true;
      }
      return false;
    },
  },
  methods: {
    dataFormat() {
      // if (this.model.dateAttendance == "") this.model.dateAttendance = null;
      if (!this.model.dateAttendance)
        if (this.model.dateAttendance == "") this.model.dateAttendance = null;
      if (!this.model.dateAttendanceChange)
        if (this.model.dateAttendanceChange == "")
          this.model.dateAttendanceChange = null;

      if (this.model.dateAttendanceExpiration == "")
        this.model.dateAttendanceExpiration = null;

      // if (this.model.dateDeliveryForecast == "")
      //   this.model.dateDeliveryForecast = null;
      if (!this.model.dateDeliveryForecast)
        if (this.model.dateDeliveryForecast == "")
          this.model.dateDeliveryForecast = null;

      if (this.model.status == "") this.model.status = 1;
      this.model.status = parseInt(this.model.status);

      if (this.model.destinationCityId == "")
        this.model.destinationCityId = null;
      this.model.destinationCityId = parseInt(this.model.destinationCityId);

      if (this.model.destinationStateId == "")
        this.model.destinationStateId = null;
      this.model.destinationStateId = parseInt(this.model.destinationStateId);

      if (this.model.originCityId == "") this.model.originCityId = null;
      this.model.originCityId = parseInt(this.model.originCityId);

      if (this.model.originStateId == "") this.model.originStateId = null;
      this.model.originStateId = parseInt(this.model.originStateId);

      if (this.model.vehicleTypeId == "") this.model.vehicleTypeId = null;
      this.model.vehicleTypeId = parseInt(this.model.vehicleTypeId);

      // isStatusChecklistLoading
      if (!this.model.checklistId)
        if (this.model.checklistId != "")
          this.model.checklistId = parseInt(this.model.checklistId);

      // isStatusWaitingCollect
      if (!this.model.loadingStartDate)
        if (this.model.loadingStartDate == "")
          this.model.loadingStartDate = null;

      // isStatusWaitingDocuments
      if (!this.model.loadingEndDate)
        if (this.model.loadingEndDate == "") this.model.loadingEndDate = null;

      // isStatusInTraffic
      if (!this.model.transportStartDate)
        if (this.model.transportStartDate == "")
          this.model.transportStartDate = null;

      // isStatusWaitingUnload
      if (!this.model.arrivalDateAtDestination)
        if (this.model.arrivalDateAtDestination == "")
          this.model.arrivalDateAtDestination = null;

      // isStatusUnloading
      if (!this.model.unloadStartDate)
        if (this.model.unloadStartDate == "") this.model.unloadStartDate = null;

      // isStatusDelivered
      if (!this.model.deliveryDate)
        if (this.model.deliveryDate == "") this.model.deliveryDate = null;

      //CargoPath
      if (this.model.cargoPath) {
        this.model.cargoPath.forEach((cargoPath) => {
          // console.log("cargoPath");
          // console.log(cargoPath);
          //destinationCityId
          if (cargoPath.destinationCityId == "")
            cargoPath.destinationCityId = null;
          cargoPath.destinationCityId = parseInt(cargoPath.destinationCityId);
          //destinationStateId
          if (cargoPath.destinationStateId == "")
            cargoPath.destinationStateId = null;
          cargoPath.destinationStateId = parseInt(cargoPath.destinationStateId);
          //originCityId
          if (cargoPath.originCityId == "") cargoPath.originCityId = null;
          cargoPath.originCityId = parseInt(cargoPath.originCityId);
          //originStateId
          if (cargoPath.originStateId == "") cargoPath.originStateId = null;
          cargoPath.originStateId = parseInt(cargoPath.originStateId);
        });
      }
    },
    dateToString(date) {
      if (date) {
        if (date != null && date != "") {
          return date.split("T")[0];
        }
      }
      return null;
    },
    loadStates() {
      this.$api
        .get("/state/getDropdownOptions")
        .then((response) => {
          this.optionsState = response.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    loadOccurrencies() {
      this.$api
        .get("/v2/occurrenceType/dropdownOptions")
        .then((response) => {
          this.cargoTypes = response.data;
          this.loadOptionsStatus();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    loadOptionsStatus() {
      if (!this.cargoTypes) {
        this.optionsStatus = [{ value: 0, text: "Carregando..." }];
        return;
      }
      if (!this.model) {
        this.optionsStatus = [{ value: 0, text: "Carregando..." }];
        return;
      }
      if (!this.model.cargoTypeId) {
        this.optionsStatus = [{ value: 0, text: "Carregando..." }];
        return;
      }
      let r = [];
      this.cargoTypes.forEach((c) => {
        if (c.id == this.model.cargoTypeId) {
          c.status.forEach((s) => {
            r.push({ value: s.value, text: s.text });
          });
        }
      });
      this.optionsStatus = r;
    },
    loadVehicleTypes() {
      this.$api
        .get("/vehicleType/dropdownOptions")
        .then((response) => {
          // console.log('vehicletype');
          // console.log(response);
          // console.log(response.data);
          this.optionsVehicleType = response.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    refreshModel() {
      if (this.model) {
        this.model.dateAttendance = this.dateToString(
          this.model.dateAttendance
        );
        this.model.dateAttendanceChange = this.dateToString(
          this.model.dateAttendanceChange
        );
        this.model.dateAttendanceExpiration = this.dateToString(
          this.model.dateAttendanceExpiration
        );
        this.model.dateDeliveryForecast = this.dateToString(
          this.model.dateDeliveryForecast
        );

        // isStatusWaitingCollect
        this.model.loadingStartDate = this.dateToString(
          this.model.loadingStartDate
        );

        // isStatusWaitingDocuments
        this.model.loadingEndDate = this.dateToString(
          this.model.loadingEndDate
        );

        // isStatusInTraffic
        this.model.transportStartDate = this.dateToString(
          this.model.transportStartDate
        );

        // isStatusWaitingUnload
        this.model.arrivalDateAtDestination = this.dateToString(
          this.model.arrivalDateAtDestination
        );

        // isStatusUnloading
        this.model.unloadStartDate = this.dateToString(
          this.model.unloadStartDate
        );

        // isStatusDelivered
        this.model.deliveryDate = this.dateToString(this.model.deliveryDate);
        // if (this.model.dateAttendance != null) this.model.dateDeliveryForecast = this.model.dateDeliveryForecast.split("T")[0];
        // if (this.model.dateAttendance != null) this.model.dateAttendance = this.model.dateAttendance.split("T")[0];

        this.$forceUpdate();
      }
    },
    async loadImg() {
      if (this.model) {
        this.$api
          .request({
            url: `${this.$store.state.urlTracking}/v1/cargo/attachment/${this.model.cargoId}/11`,
            method: "GET",
            responseType: "arraybuffer", //important
          })
          .then((response) => {
            this.attachmentUrl = window.URL.createObjectURL(
              new Blob([response.data], {
                type: response.headers["content-type"],
              })
            );
          })
          .catch((error) => {
            console.log(error);
            console.log(error.response.data.errors);
            if (error.response.status == 400) {
              console.log(error.response.data.errors);
            }
          });
      }
      return "";
    },
    openImage() {
      this.attachmentUrl = "";
      this.loadImg();
      this.$refs.fullscreenSidebar.open();
    },
  },
  watch: {
    model() {
      this.refreshModel();
    },
    "model.cargoTypeId": function (newValue, oldValue) {
      this.loadOptionsStatus();
    },
  },
};
</script>
